import { Provider } from "react-redux";

import { NotificationAlert } from "common/components/notificationAlert";
import { MaterialThemeProvider } from "provider";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import RoutsLayout from "./routes";
import { ErrorBoundary } from "ErrorBoundary";
import { ScrollToTop } from "modules/scrollToTop";
import { initLoginFromQuery } from "common/customHook/initLoginFromQuery";
import CustomThemeContextProvider from "common/context/customTheme/customThemeContext";

function App({ store }) {
  initLoginFromQuery();
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <CustomThemeContextProvider>
          <MaterialThemeProvider>
            <Router>
              <RoutsLayout />
              <ScrollToTop />
            </Router>
          </MaterialThemeProvider>
        </CustomThemeContextProvider>
        <NotificationAlert />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
